export function select (elements, parent = document) {
    if(typeof elements === 'string') {
        elements = parent.querySelectorAll(elements)
    }
    return [].map.call(elements, el => el)
}

export function scrollTo (position) {
    if(window.jQuery) {
        $('html, body').animate({ scrollTop: position }, 500)
    } else {
        document.documentElement.scrollTop = document.body.scrollTop = position
    }
}


export function parseData (element, attribute = 'data-svg') {
    const attr = element.getAttribute(attribute)
    if (!attr) return false
    const data = JSON.parse(attr.replace(/'/g, '"'))
    return data
}
